import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { tomos } from '../data/tomos';
export function Tomos() {
  return <section aria-labelledby="tomos-titulo" className="w-full bg-surface px-6 py-20" data-id="element-222" data-mp="13cza60rn8bad">
      <div className="mx-auto max-w-content" data-id="element-223" data-mp="1h3ckuavx643e">
        <div className="text-center" data-id="element-224" data-mp="1h574zmzd9s6f">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-soft" data-id="element-225" data-mp="1cbuflamv5hcm">
            <BookOpenIcon className="h-6 w-6 text-brand-700" aria-hidden="true" data-id="element-226" data-mp="1r0qv1sr91wn9" />
          </span>
          <h2 id="tomos-titulo" className="mt-4 font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-227" data-mp="1m2p4kmrhuv1r">
            6 Tomos completos
          </h2>
          <p className="mt-4 text-muted" data-id="element-228" data-mp="2015j2zvllpug">Contenido aplicado para cada área de tu trabajo</p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-229" data-mp="1vy8wyz6unblr">
          {tomos.map(tomo => <li key={tomo.numero} className="flex h-full flex-col overflow-hidden rounded-3xl border border-edge bg-canvas transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-230" data-mp="5pqtqk6i1sf8">
              <div className="border-b border-edge bg-soft p-5" data-id="element-231" data-mp="39p9uofvg19h9">
                <img src={tomo.imagen} alt={`Caja del Tomo ${tomo.numero}: ${tomo.nombre}`} className="aspect-square w-full object-contain" width={1024} height={1024} data-id="element-232" data-mp="39ngkwrpja951" />
              </div>
              <div className="flex flex-1 flex-col p-7" data-id="element-233" data-mp="3ogs4fvxpm7s6">
                <span className="font-display text-2xl font-bold text-brand-300" data-id="element-234" data-mp="3sf9f2pgca0ec">{tomo.numero}</span>
                <h3 className="mt-2 flex items-start gap-2 font-display text-xl font-bold leading-snug text-ink" data-id="element-235" data-mp="1b18bpjilexj">
                  <span aria-hidden="true" data-id="element-236" data-mp="68kkmjwnjhmu">{tomo.emoji}</span>
                  <span data-id="element-237" data-mp="231w2ye1zj82o">{tomo.nombre}</span>
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-238" data-mp="233pdi4fpycfy">{tomo.descripcion}</p>
                <p className="mt-auto pt-5 text-xs font-semibold uppercase tracking-wider text-brand-700" data-id="element-239" data-mp="282jvj45v3wz0">
                  {tomo.meta}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}